/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_shipmentQuote = {
    readonly isCustom: boolean | null;
    readonly isNew: boolean | null;
    readonly status: string | null;
    readonly " $refType": "PdpSharedShippingInfoLink_shipmentQuote";
};
export type PdpSharedShippingInfoLink_shipmentQuote$data = PdpSharedShippingInfoLink_shipmentQuote;
export type PdpSharedShippingInfoLink_shipmentQuote$key = {
    readonly " $data"?: PdpSharedShippingInfoLink_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfoLink_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustom",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isNew",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '904e872823396a128469f00e8319c6cb';
export default node;
